<template src="./UserProfile.html"></template>

<script>
// css Imports
import './UserProfile.scss';
// Services Imports
import { userService } from "@/services";
// Third party Imports
import VueElementLoading from "vue-element-loading";
import { mapState, mapActions } from "vuex";
// Components Imports
import EventPost from "../../components/EventPost";
import topnavbar from "../../views/Topnavbar";
import { VueFinalModal } from "vue-final-modal";

import unauthorizedUser from "../unauthorizedUser/unauthorizedUser.vue";

export default {
  name: "UserProfile",
  data() {
    return {
      myEventslist: [],
      showModel: false,
      followed: false,
      show: false,
      user: {},
      isLoading: false,
      loadStyle: {
        color: "#ffffff",
        "font-weight": "bold",
        "letter-spacing": "1rem",
        "font-size": "18px",
      }
    }
  },
  watch: {
    myprofileEventsStatus(v) {
      this.isLoading = v === "pending";
    },
    myProfileEvents(v) {
      if (v.length > 0) {
       this.myEventslist = this.sortby(JSON.parse(JSON.stringify(v)))
      }
    }
  },
  components: {
    VueElementLoading,
    EventPost,
    topnavbar,
    VueFinalModal,
    unauthorizedUser
  },
  computed: {
    ...mapState("events", ["myProfileEvents", "myprofileEventsStatus"]),
    localId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions("account", ["followUser", "unfollowUser"]),
    ...mapActions("events", ["getMyProfileEvents"]),
    toggle(value) {
      this.show = value;
    },
    sortby(list) {
     return [...list.sort(function (a, b) {
        return new Date(a.startDateTime || null) - new Date(b.startDateTime || null);
      })];
    },
    closeModel() {
      this.showModel = false;
    },
    setLoader(v) {
      if (v) {
        this.isLoading = true;
      } else if (!v) {
        this.isLoading = false;
      }
    },
    setFollowEvent() {
      this.$CURRENT_USER.getUser();
      if (!this.$CURRENT_USER.user) {
        this.showModel = true;
        return;
      }

      var vm = this;
      const arr =
        this.$CURRENT_USER && this.$CURRENT_USER.user
          ? (this.$CURRENT_USER.user.followings || []).map((x) => x.followedUserId)
          : [];
      if (
        this.$CURRENT_USER &&
        this.$CURRENT_USER.user &&
        arr.includes(this.$route.params.id)
      ) {
        this.unfollowUser({
          followerUserId: this.$CURRENT_USER.user.userId,
          followedUserId: this.$route.params.id,
        }).then((res) => {
          let userSession = localStorage.getItem("user");

          if (userSession && !res.error) {
            userSession = JSON.parse(userSession);
            userSession.followings = res;
            localStorage.setItem("user", JSON.stringify(userSession));
            vm.$toast.success("Unfollowed successfully", { timeout: 4000 });

            setTimeout(() => {
              this.followed = false;
              this.$CURRENT_USER.getUser();
            }, 100);
          } else {
            vm.$toast.error("Request Failed", { timeout: 4000 });
          }
        });
      } else if (
        this.$CURRENT_USER &&
        this.$CURRENT_USER.user &&
        !arr.includes(this.$route.params.id)
      ) {
        this.followUser({
          followerUserId: this.$CURRENT_USER.user.userId,
          followedUserId: this.$route.params.id,
        }).then((res) => {
          let userSession = localStorage.getItem("user");

          if (userSession && !res.error) {
            userSession = JSON.parse(userSession);
            userSession.followings = res;
            localStorage.setItem("user", JSON.stringify(userSession));
            vm.$toast.success("Followed successfully", { timeout: 4000 });
            setTimeout(() => {
              this.followed = true;
              this.$CURRENT_USER.getUser();
            }, 100);
          } else {
            vm.$toast.error("Request Failed", { timeout: 4000 });
          }
        });
      }
    },
    getYears(createdAt) {
      if (
        new Date().getFullYear() -
          new Date(createdAt).getFullYear() >
        0
      ) {
        return (
          new Date().getFullYear() -
          new Date(createdAt).getFullYear() +
          " year(s) ago"
        );
      } else if (12 - new Date(createdAt).getMonth() + 1 > 0) {
        return (
          12 - new Date(createdAt).getMonth() + 1 + " month(s) ago"
        );
      }

      return "Joined this year";
    }
  },
  mounted() {
    this.isLoading = true;
    userService.getLoggedInUser(this.$route.params.id)
    .then((response) => {
      this.user = response;
    })
    this.followed = this.$CURRENT_USER.user ?
      (this.$CURRENT_USER.user.followings.filter(
        (x) => x.followedUserId == this.$CURRENT_USER.user.userId
      ).length > 0) : false;
    // fetching my events
    this.getMyProfileEvents({
      userId: this.$route.params.id,
      page: 1,
    });
  }
};
</script>
